<template>
  <div
    :class="'slidePlayerComponentContainer ' + (docked ? 'slideDocked' : 'showPadding')"
    ref="slidePlayerComponentContainer"
    :style="initialPrefs.isSlideVisible ? 'display:block' : 'display:none'"
  >
    <vue-draggable-resizable
      id="slideContent"
      ref="slideContent"
      :lock-aspect-ratio="true"
      :w="w"
      :h="h"
      :x="x"
      :y="y"
      :onDrag="onDragCallback"
      :resizing="onResize"
      @dragstop="onDragStop"
      :resizable="isMobile ? false : true"
      :axis="isMobile ? 'y' : 'both'"
      :parent="false"
    >
      <div
        :class="
          'slidePlayer ' +
            (isDocking == true && docked == false
              ? 'beforeDockStateChange'
              : '')
        "
        ref="slidePlayer"
      >
        <div class="topContainer">
          <close-icon></close-icon>
        </div>
        <img :src="imgSrc" />
        <div
          class="textOuterContainer"
          :style="linkText == null ? 'display:none' : 'display:flex'"
        >
          <a
            :title="linkText != null ? linkText : ''"
            :href="linkURL"
            ref="SlideText"
            >{{ linkText }}</a
          >
        </div>
      </div>
    </vue-draggable-resizable>
  </div>
</template>
<script>
import VueDraggableResizable from "vue-draggable-resizable";
import Vue from 'vue'
import "vue-draggable-resizable/dist/VueDraggableResizable.css";
import "../scss/slide-player.css";
export default {
  props: {
    overlayContent: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      imgSrc: "./SlidesLoading.svg",
      linkText: null,
      linkURL: "#",
      windowWidth: window.innerWidth,
      loadedOnce: false,
      w: 320,
      h: 180,
      x: 160,
      y: 90,
      slideDockerDiv: null,
      isDocking: false,
      docked: false,
      dockingTimeout: null,
      isDragging: false,
      slides: [],
      isVisible: false,
      showPadding:false,
      paddingTimeout:null
    };
  },
  methods: {
    onResize: function(x, y, width, height) {
      this.x = x;
      this.y = y;
      this.width = width;
      this.height = height;
    },
    onDragCallback(x, y) {
      this.showPadding=true;
      this.clearPadding();
      if (!this.isDragging) {
        this.x = x;
        this.y = y;
        this.isDragging = true;
        return false;
      }
      if (!this.docked) {
        let containerCoordinate = this.$refs.slidePlayerComponentContainer.getBoundingClientRect();
        let slideCoordinate = this.$refs.slidePlayer.getBoundingClientRect();
        if (x < -containerCoordinate.left + 10 && this.x > x) {
          this.$refs.slideContent.$el.style.transform =
            "translate(" +
            (-containerCoordinate.left + 10) +
            "px," +
            this.y +
            "px)";
          this.x = -containerCoordinate.left + 10;
          return false;
        }
        if (
          x >
            window.innerWidth -
              containerCoordinate.left -
              slideCoordinate.width -
              10 &&
          this.x < x
        ) {
          this.$refs.slideContent.$el.style.transform =
            "translate(" +
            (window.innerWidth -
              containerCoordinate.left -
              slideCoordinate.width -
              10) +
            "px," +
            this.y +
            "px)";
          this.x =
            window.innerWidth -
            containerCoordinate.left -
            slideCoordinate.width -
            10;
          return false;
        }
        if (y < -containerCoordinate.top + 10 && this.y > y) {
          this.$refs.slideContent.$el.style.transform =
            "translate(" +
            this.x +
            "px," +
            (-containerCoordinate.top + 10) +
            "px)";
          this.y = -containerCoordinate.top + 10;
          return false;
        }
        if (
          y >
            window.innerHeight -
              containerCoordinate.top -
              slideCoordinate.height -
              10 &&
          this.y < y
        ) {
          this.$refs.slideContent.$el.style.transform =
            "translate(" +
            this.x +
            "px," +
            (window.innerHeight -
              containerCoordinate.top -
              slideCoordinate.height -
              10) +
            "px)";
          this.y =
            window.innerHeight -
            containerCoordinate.top -
            slideCoordinate.height -
            10;
          if (this.isMobile) {
            this.isDocking = true;
            if (this.dockingTimeout == null) {
              this.dockingTimeout = setTimeout(() => {
                if (this.isDocking) this.docked = true;
              }, 700);
            }
          }
          return false;
        }
      }
      if (this.dockingTimeout != null) {
        clearTimeout(this.dockingTimeout);
        this.dockingTimeout = null;
      }
      this.isDocking = false;
      this.docked = false;

      this.x = x;
      this.y = y;
    },
    process(curTime) {
      var i = 0;
      var lastTime = -1;
      var slideIndex = 0;
      for (i = 0; i < this.slides.length; i++) {
        if (this.slides[i].showTimeInSeconds < curTime) {
          if (this.slides[i].showTimeInSeconds > lastTime) {
            lastTime = this.slides[i].showTimeInSeconds;
            slideIndex = i;
          }
        }
      }
      this.imgSrc = "./slides/" + this.slides[slideIndex].path;
      this.linkURL = this.slides[slideIndex].linkURL;
      this.linkText = this.slides[slideIndex].linkText;
    },
    clearPadding(){
      clearTimeout(this.paddingTimeout)
      this.paddingTimeout=setTimeout(() => {
        this.showPadding=false
      }, 1000);
    },
    onDragStop() {
      this.isDragging = true;
      this.isDocking = false;
    },
    resized() {
      this.windowWidth = window.innerWidth;
    },
    resetXtranslate() {
      this.$refs.slideContent.left = 0;
      this.$refs.slideContent.top =
        window.screen.availHeight -
        this.$refs.slidePlayer.getBoundingClientRect().height -
        80;
    },
    processVisible() {
      if (this.isMobile && this.loadedOnce == false) {
        this.$nextTick(() => {
          this.resetXtranslate();
        });
      }
      this.loadedOnce = true;
    },
    toggleVisible() {
      this.initialPrefs.isSlideVisible = !this.initialPrefs.isSlideVisible;
      if (this.initialPrefs.isSlideVisible) {
        this.processVisible();
      }
    },
  },
  components: {
    "vue-draggable-resizable": VueDraggableResizable
  },
  created() {
    window.addEventListener("resize", this.resized);
    this.slides.map((x) => {
      x.showTimeInSeconds = this.convertHoursMinsSecsToSeconds(x.showTime);
      return x;
    });
    this.slides = this.overlayContent.slides;
    Vue.set(this.overlayContent, "isSlideVisible", false);

  },
  computed: {
    isMobile: function() {
      return this.windowWidth <= window.mobileWidth;
    }
  },
  watch: {
    isMobile(newValue) {
      if (newValue == true) {
        this.resetXtranslate();
      }
    }
  }
};
</script>
<style></style>
